import { Column, Divider, Padding, Row, SizedBox } from "../../../common/components/CommonBaseComponents";
import CustomImage from "../../../common/components/image/CustomImage";
import { C2Text, C3Text, C4Text } from "../../../common/components/text/CustomText";
import CustomIcon from "../../../common/components/image/CustomIcon";
import UIUtil from "../../../common/utils/UIUtil";
import Translate from "../../../common/translate/Translate";
import { CustomAbsolutePositionDropdownWrapper } from "../../../common/components/dropdown/CustomDropdownWrapper";
import { Theme } from "../../../common/Theme";

function DeviceMenu({ device, onHistoryClick, onSettingClick, onDiagnosisClick, onMemoClick, ...props }) {
    const { statusTextColor, statusBackgroundColor, statusIcon, statusText } = UIUtil.getDeviceStatusUI(device.status);

    return (
        <CustomAbsolutePositionDropdownWrapper openedLeftSide={true} top={props.top} left={"-203px"} width={"240px"}>
            <Row justifyContent={"space-between"} gap={"8px"} width={"100%"} padding={"18px 16px 6px 24px"}>
                <Row flex={"1"} minWidth={"0"}>
                    <CustomImage imageName={`image_${device.type}`} width={"29px"} height={"36px"} />
                    <SizedBox width={"14px"} />
                    <Column flex={"1"} minWidth={"0"} justifyContent={"flex-start"} alignItem={"flex-start"}>
                        <C4Text>{device.type}</C4Text>
                        <SizedBox height={"4px"} />
                        <C3Text fontWeight={"500"} fontColor={Theme.color.black} width={"100%"} useEllipsis>
                            {device.name}
                        </C3Text>
                    </Column>
                </Row>
                <SizedBox
                    width={"auto"}
                    height={"auto"}
                    padding={"5px 4px"}
                    borderRadius={"6px"}
                    backgroundColor={statusBackgroundColor}
                >
                    <Row>
                        <CustomIcon iconName={statusIcon} size={"18px"} />
                        <SizedBox width={"4px"} />
                        <C2Text fontColor={statusTextColor}>{statusText}</C2Text>
                    </Row>
                </SizedBox>
            </Row>
            <Divider marginTop={"10px"} />
            <Padding padding={"6px 8px"}>
                <SizedBox
                    padding={"12px 9px"}
                    cursor={"pointer"}
                    width={"100%"}
                    height={"auto"}
                    hoverBackgroundColor={Theme.color.neutral100}
                    borderRadius={"4px"}
                    onClick={onHistoryClick}
                >
                    <Row justifyContent={"flex-start"} width={"100%"} cursor={"pointer"}>
                        <CustomIcon iconName={"alarm_black"} size={"18px"} cursor={"pointer"} />
                        <SizedBox width={"8px"} />
                        <C2Text>{Translate("store.deviceMenu.history")}</C2Text>
                    </Row>
                </SizedBox>
                <SizedBox
                    padding={"12px 9px"}
                    cursor={"pointer"}
                    width={"100%"}
                    height={"auto"}
                    hoverBackgroundColor={Theme.color.neutral100}
                    borderRadius={"4px"}
                    onClick={onSettingClick}
                >
                    <Row justifyContent={"flex-start"} width={"100%"} cursor={"pointer"}>
                        <CustomIcon iconName={"settings_black"} size={"18px"} cursor={"pointer"} />
                        <SizedBox width={"8px"} />
                        <C2Text>{Translate("store.deviceMenu.setting")}</C2Text>
                    </Row>
                </SizedBox>
                <SizedBox
                    padding={"12px 9px"}
                    cursor={"pointer"}
                    width={"100%"}
                    height={"auto"}
                    hoverBackgroundColor={Theme.color.neutral100}
                    borderRadius={"4px"}
                    onClick={onDiagnosisClick}
                >
                    <Row justifyContent={"flex-start"} width={"100%"} cursor={"pointer"}>
                        <CustomIcon iconName={"diagnosis"} size={"18px"} cursor={"pointer"} />
                        <SizedBox width={"8px"} />
                        <C2Text>{Translate("store.deviceMenu.diagnosis")}</C2Text>
                    </Row>
                </SizedBox>
                <SizedBox
                    padding={"12px 9px"}
                    cursor={"pointer"}
                    width={"100%"}
                    height={"auto"}
                    hoverBackgroundColor={Theme.color.neutral100}
                    borderRadius={"4px"}
                    onClick={onMemoClick}
                >
                    <Row justifyContent={"flex-start"} width={"100%"} cursor={"pointer"}>
                        <CustomIcon iconName={"edit"} size={"18px"} cursor={"pointer"} />
                        <SizedBox width={"8px"} />
                        <C2Text>{Translate("store.deviceMenu.memo")}</C2Text>
                    </Row>
                </SizedBox>
            </Padding>
        </CustomAbsolutePositionDropdownWrapper>
    );
}

export default DeviceMenu;
